import { withStyles } from '@material-ui/core/styles';
import styles from './ProductItem.styles';
import ProductItem from './ProductItem';

export default withStyles(styles)(ProductItem);
